import CarRentalSubhead from "./CarRentalSubhead";
import { lazy, Suspense } from "react";

const ShuttleTeamLogo = lazy(() => import("../shuttle_software/ShuttleTeamLogo"));
const FleetEarning = lazy(() => import("./FleetEarning"));
const CarMobility = lazy(() => import("./CarMobility"));
const CarInfotech = lazy(() => import("./CarInfotech"));
const CarControl = lazy(() => import("./CarControl"));
const ShuttlItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const SuccessKey = lazy(() => import("./SuccessKey"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const carRentalFeatureId = "car-rental-software";
export default function CarRental() {

  return (
    <>
      <CarRentalSubhead featureId={carRentalFeatureId} />
      <Suspense fallback={null}>
        <ShuttleTeamLogo />
        <FleetEarning />
        <CarMobility />
        <CarInfotech />
        <CarControl />
        <SuccessKey />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttlItNeed featureId={carRentalFeatureId} />
      </Suspense>
    </>
  );
}
